import { render, staticRenderFns } from "./collection-report.pug?vue&type=template&id=05c1a15a&scoped=true&lang=pug&"
import script from "./collection-report.ts?vue&type=script&lang=ts&"
export * from "./collection-report.ts?vue&type=script&lang=ts&"
import style0 from "./collection-report.styl?vue&type=style&index=0&id=05c1a15a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1a15a",
  null
  
)

export default component.exports